import { Navigate } from "react-router-dom";
import { ReactElement, useEffect, useState } from "react";
import { authSession } from "../utils/authService";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";

const PrivateRoute: React.FC<{ children: ReactElement }> = ({ children }) => {

  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchAccessToken = async () => {
      const token = await authSession();
      setAccessToken(token ?? null);
      setIsLoading(false);
    };

    fetchAccessToken();
  }, []);

  // Always allow access to meeting routes
  if (isLoading) {
    return <LoadingSpinner />
  } else if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default PrivateRoute;